export const navigationLinks = [
  { name: 'Inicio', href: '#inicio' },
  { name: 'Nosotros', href: '#nosotros' },
  { name: 'Servicios', href: '#servicios' },
  { name: 'Servicio de PLD', href: '#pld' },
  { name: 'ISO', href: '#iso' },
  { name: 'Nuestro equipo', href: '#equipo' },
  { name: 'Blog', href: '#blog' },
  { name: 'Contáctanos', href: '#contacto' }
];

export const badges = [
  { icon: 'Scale', title: 'Legalidad' },
  { icon: 'Award', title: 'Certificación' },
  { icon: 'Lock', title: 'Blockchain' },
  { icon: 'Lightbulb', title: 'Innovación' }
];

export const services = [
  {
    id: 1,
    title: 'Notaría Digital',
    subtitle: 'Certificación notarial con transparencia blockchain.',
    image: 'https://customer-assets.emergentagent.com/job_public-notary-lab/artifacts/ewfayz79_fondo.jpg',
    features: [
      'Protocolización de documentos en entornos digitales.',
      'Validación de identidad y firma electrónica avanzada.',
      'Certificación inmutable en blockchain para mayor seguridad.',
      'Acceso rápido y confiable a documentos digitales.'
    ]
  },
  {
    id: 2,
    title: 'Protección Patrimonial',
    subtitle: 'Blindaje legal y tecnológico de tus bienes.',
    image: 'https://customer-assets.emergentagent.com/job_public-notary-lab/artifacts/ewfayz79_fondo.jpg',
    features: [
      'Estrategias notariales para proteger activos físicos y digitales.',
      'Registro seguro en blockchain para mayor certeza.',
      'Prevención de fraudes y duplicidad de documentos.',
      'Planeación sucesoria con respaldo tecnológico.'
    ]
  },
  {
    id: 3,
    title: 'Contratos Inteligentes',
    subtitle: 'Seguridad y validez en entornos digitales.',
    image: 'https://customer-assets.emergentagent.com/job_public-notary-lab/artifacts/ewfayz79_fondo.jpg',
    features: [
      'Redacción y validación de contratos automatizados.',
      'Integración de cláusulas con ejecución automática.',
      'Garantía de trazabilidad y cumplimiento sin intermediarios.',
      'Adaptación de contratos a marcos legales vigentes.'
    ]
  },
  {
    id: 4,
    title: 'Consultoría Empresarial',
    subtitle: 'Estrategias jurídicas y corporativas.',
    image: 'https://customer-assets.emergentagent.com/job_public-notary-lab/artifacts/ewfayz79_fondo.jpg',
    features: [
      'Asesoría en constitución y formalización de empresas.',
      'Planeación legal y fiscal para negocios en crecimiento.',
      'Diseño de estructuras corporativas seguras y eficientes.',
      'Cumplimiento normativo en entornos tradicionales y digitales.'
    ]
  }
];

export const legalServices = [
  {
    icon: 'Briefcase',
    title: 'Derecho Mercantil',
    description: 'Somos los especialistas en regular los actos de comercio y las relaciones entre comerciantes. Somos los especialistas en regular los actos de comercio'
  },
  {
    icon: 'Users',
    title: 'Derecho Civil',
    description: 'Regulamos las relaciones civiles y jurídicas de la vida cotidiana de las personas, relaciones familiares, propiedad, obligaciones y contratos.'
  },
  {
    icon: 'Home',
    title: 'Derecho Inmobiliario',
    description: 'Somos especialistas en todas las operaciones en cuanto a la enajenación de bienes inmuebles y las transacciones comerciales relativas.'
  },
  {
    icon: 'FileText',
    title: 'Otros',
    description: 'Ayudamos y asesoramos en todos los demás trámites notariales.'
  }
];

export const contactInfo = {
  phones: ['52 (984) 185 5185', '+52 (984) 803 0555'],
  whatsapp: '+52 (984) 185 5185',
  email: 'recepcion@notariapublica90.com',
  address: '5ta avenida con 42 norte edificio Tan-Ik, piso Mezzanine, Col. Zazil Ha. Playa del Carmen Quintana Roo.'
};

export const notaryPhotos = [
  'https://customer-assets.emergentagent.com/job_public-notary-lab/artifacts/bja98jpd_Copia%20de%20DSC08171.jpg',
  'https://customer-assets.emergentagent.com/job_public-notary-lab/artifacts/ccjuf9aq_DSC08034.jpg',
  'https://customer-assets.emergentagent.com/job_public-notary-lab/artifacts/79y4xzyu_DSC06957.jpg'
];
